import { apiService } from './api';

export interface VisibleTabsResponse {
  visibleTabKeys: string[];
}

export async function getVisibleTabKeys(): Promise<string[]> {
  const data = await apiService.get<VisibleTabsResponse>('/api/config/visible-tabs');
  return data?.visibleTabKeys ?? [];
}
